// Dependenceis
import React, { createClass, PropTypes } from 'react';
import getClassNames from 'classnames';
// Components
import Icon from '../tc-ui/icon';
import { IconButton, RaisedButton } from 'material-ui';

import { Paper } from 'material-ui';
import ClickAwayListener from 'material-ui/internal/ClickAwayListener';

const DropDown = createClass({
  propTypes: {
    toggleZIndex: PropTypes.func,
    payload: PropTypes.string,
    acceptConnection: PropTypes.func,
    ignoreConnection: PropTypes.func,
    iconClassName: PropTypes.string,
    tooltip: PropTypes.bool,
    options: PropTypes.array,
    className: PropTypes.string,
    isRequest: PropTypes.bool,
    label: PropTypes.string,
    componentClassName: PropTypes.string,
    style: PropTypes.object,
  },

  getInitialState() {
    return {
      showDropDown: false,
      isOnNestedMultiselect: false,
      menuMap: [],
    };
  },

  _toggleZIndex() {
    if (this.props.toggleZIndex) this.props.toggleZIndex();
  },

  componentClickAway() {
    if (this.state.showDropDown) {
      this._toggleZIndex();
    }
    this._resetState();
  },

  _resetState() {
    this.setState(this.getInitialState());
  },

  actionButtonClicked() {
    this.setState(
      {
        showDropDown: !this.state.showDropDown,
      },
      () => this._toggleZIndex(),
    );
  },

  optionClicked(option, index) {
    switch (option.type) {
      case 'nestedmenu':
        // show the other menu
        this.state.menuMap.push(index);
        this.setState({
          menuMap: this.state.menuMap,
          isOnNestedMultiselect: option.isOnNestedMultiselect,
        });
        break;

      default:
        if (option.action) {
          option.action.call(this, this.props.payload);
        }
        if (!option.leaveMenuOpen) {
          this._toggleZIndex();
          this._resetState();
        }
        break;
    }
  },

  acceptConnection() {
    this.props.acceptConnection(this.props.payload);
  },

  ignoreConnection() {
    this.props.ignoreConnection(this.props.payload);
  },

  _showPrevious() {
    this.state.menuMap.pop();
    this.setState({
      menuMap: this.state.menuMap,
      isOnNestedMultiselect: false,
    });
  },

  render() {
    let acceptButton;
    let rejectButton;
    const iconClassName = this.props.iconClassName || 'tc-icon-more-vert';
    const tooltip = this.props.tooltip === false ? undefined : 'More Actions';

    let menuToDisplay = this.props.options;
    let menuText;
    let filterIcon;
    this.state.menuMap.forEach(index => {
      menuText = menuToDisplay[index].text;
      menuToDisplay = menuToDisplay[index].subOptions;
    });

    const menu = menuToDisplay.map((option, index) => {
      return (
        <div
          onClick={() => this.optionClicked(option, index)}
          className="connections-action-drop-down-link"
          key={index}
        >
          {' '}
          {option.text} {option.icon}{' '}
        </div>
      );
    });
    const classes = getClassNames('connections-action-drop-down', this.props.className, {
      'is-closed': !this.state.showDropDown,
      'is-vert-multi-select': this.state.isOnNestedMultiselect,
    });
    const previousButton = this.state.menuMap.length ? (
      <div onClick={this._showPrevious} className="connections-action-drop-down-link">
        {' '}
        <Icon className="tc-icon-chevron-left" />
        {menuText}
      </div>
    ) : null;

    if (this.props.isRequest) {
      acceptButton = (
        <RaisedButton
          backgroundColor="green"
          labelStyle={{ color: 'white' }}
          onTouchTap={this.acceptConnection}
          label="Add Partner"
        />
      );
      rejectButton = <RaisedButton primary onTouchTap={this.ignoreConnection} label="Reject" />;
    }

    if (this.props.label) {
      filterIcon = (
        <div className="more-vert-label" onClick={this.actionButtonClicked}>
          {this.props.label}
        </div>
      );
    } else {
      filterIcon = (
        <IconButton
          iconClassName={iconClassName}
          style={{ zIndex: 0 }}
          onTouchTap={this.actionButtonClicked}
          tooltip={tooltip}
        />
      );
    }
    return (
      <ClickAwayListener onClickAway={this.componentClickAway}>
        <div
          className={this.props.componentClassName}
          style={{ ...this.props.style, display: 'flex', position: 'relative', zIndex: 0 }}
        >
          <div style={{ marginTop: '6px' }}>
            {rejectButton}&nbsp;&nbsp;{acceptButton}
          </div>
          <div className={classes}>
            <Paper style={{ padding: '8px 16px' }}>
              <div className="connections-action-container">
                {previousButton}
                {menu}
              </div>
            </Paper>
          </div>
          {filterIcon}
        </div>
      </ClickAwayListener>
    );
  },
});

export default DropDown;



// WEBPACK FOOTER //
// ./src/app/components/connections/connections-vert-dropdown.jsx